<template>
    <div class="tw-mt-12 tw-px-8 lg:tw-px-0">
        <h3 class="tw-text-infinity-highlight tw-mb-6">Service Quotation <small class="tw-text-infinity-tertiary-text">#{{
                quotation.quote_number
            }}</small>
        </h3>
        <div class="tw-text-infinity-primary-text tw-mb-6">Please find below the requested quotation for your service
            inquiry.
        </div>
        <div class="tw-grid tw-gap-4 md:tw-grid-flow-col tw-items-start quotation-grid">
            <div class="tw-grid tw-gap-4">
                <BasePanel variant="secondary-outlined">
                    <BasePanelTitle>Service Details</BasePanelTitle>
                    <div>
                        <div class="tw-flex tw-space-x-3 tw-items-center">
                            <img :src="service && service.image && service.image(50)" class="tw-rounded tw-bg-grey-200"
                                 width="52" height="52"/>
                            <div class="tw-grid tw-gap-1">
                                <div class="tw-font-medium tw-text-infinity-primary-text">
                                    <router-link class=" tw-text-infinity-primary-text"
                                                 :to="{ name: 'service', params: {service: service.id}}">
                                        {{ service.name }}
                                    </router-link>
                                </div>
                                <div class="tw-flex tw-items-center tw-space-x-3">
                                    <div class="tw-text-xs tw-text-infinity-tertiary-text">
                                        <font-awesome-icon :icon="['far', 'repeat']" class="tw-mr-1"/>
                                        {{ quotation.revisions }} Revisions
                                    </div>
                                    <div class="tw-text-xs tw-text-infinity-tertiary-text">
                                        <font-awesome-icon :icon="['far', 'clock']" class="tw-mr-1"/>
                                        {{ quotation.max_delivery_days }} Days
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BasePanel>
                <BasePanel variant="primary">
                    <BasePanelTitle>Project Details</BasePanelTitle>
                    <div class="tw-grid tw-gap-2">
                        <BasePanelItem title="Title" :value="inquiry.project_name"/>
                        <BasePanelItem title="Budget">{{ inquiry.budget | displayPrice }}</BasePanelItem>
                        <BasePanelItem title="Description" :value="inquiry.project_description"/>
                    </div>
                </BasePanel>
            </div>
            <div class="tw-grid tw-gap-4">
                <BasePanel variant="secondary-outlined">
                    <BasePanelTitle>Customer Details</BasePanelTitle>
                    <div class="tw-grid tw-gap-2">
                        <BasePanelItem title="Full Name" :value="inquiry.customer_name"/>
                        <BasePanelItem title="Email" :value="inquiry.customer_email"/>
                        <BasePanelItem title="Phone" :value="inquiry.customer_phone"/>
                    </div>
                </BasePanel>
                <BasePanel variant="primary" class="tw-text-right">
                    <BasePanelTitle no-margin>Quote Total</BasePanelTitle>
                    <div class="tw-text-infinity-primary-text tw-text-md tw-font-medium">
                        {{ quotation.price | displayPrice }}
                    </div>
                </BasePanel>
                <BuyButton v-if="service && !loading" variant="boxed-big" force-text :item="service"/>
            </div>
        </div>
        <transition name="fade">
            <div v-if="loading">
                <div
                    class="tw-w-screen tw-h-screen tw-fixed tw-inset-0 tw-z-10 tw-items-center tw-justify-center tw-flex tw-bg-infinity-background-faded-modal tw-backdrop-filter tw-backdrop-blur">
                    <div class="tw-w-24">
                        <base-infinity-loading/>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import ServiceRowContainer from "../services/list/service-row-container";
import BasePanel from "../base/base-panel/BasePanel";
import BasePanelTitle from "../base/base-panel/BasePanelTitle";
import BasePanelItem from "../base/base-panel/BasePanelItem";
import BuyButton from "../shared/buy-button";
import BaseInfinityLoading from "../base/base-infinity-loading";
import ServiceQuote from "../../models/ServiceQuote";

export default {
    name: 'quotation',
    components: {BaseInfinityLoading, BuyButton, BasePanelItem, BasePanelTitle, BasePanel, ServiceRowContainer},
    data() {
        return {
            service: {},
            quotation: {},
            inquiry: {},
            loading: true,
        }
    },
    mounted() {
        this.getQuotation(this.$route.params.number);
    },
    methods: {
        async getQuotation(quoteNumber) {
            this.loading = true;
            const {data: {quote}} = await this.$http.get(`${ab.apiUrl}/infinity/services/quotation/${quoteNumber}`)
            this.quotation = quote
            this.inquiry = quote.service_inquiry
            this.service = new ServiceQuote({
                ...quote.service,
                ...quote,
            })
            this.loading = false
        },
    },
}
</script>
<style lang="scss">
.quotation-grid {
    @screen md {
        grid-template-columns: 1fr 270px;
    }
}
</style>
